var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HznSearchInput_instances, _HznSearchInput_emit, _HznSearchInput_handleSearchButtonClick;
// class definition
import { html } from '@horizon/base';
import { property, query } from '@horizon/base/decorators.js';
import { eventEmitter } from '@horizon/common/events';
import { HznInput, renderIconSlot, hasNoSlottedIcon } from '@horizon/input';
import { HznIconSearch } from '@horizon/icons/individual';
import { submit } from '@open-wc/form-helpers';
import SearchInputStyles from './search-input.css.js';
/**
 *
 * @tag hzn-search-input
 * @tagname hzn-search-input
 * @summary A plain text input specialized for search functions
 *
 * @fires {CustomEvent<{}>} search - Emitted when the search icon is interactive and clicked
 */
export class HznSearchInput extends HznInput {
    static get styles() {
        return [...super.styles, SearchInputStyles];
    }
    static get scopedElements() {
        return {
            ...super.scopedElements,
            'hzn-icon-search': HznIconSearch
        };
    }
    constructor() {
        super();
        _HznSearchInput_instances.add(this);
        /**
         * @private
         */
        _HznSearchInput_emit.set(this, eventEmitter(this));
        /**
         * Set the search icon to display as an interactive button that emits an event for performing searches
         */
        this.interactiveIcon = false;
        // default search inputs to non-sensitive always
        this.type = 'text';
        this.sensitive = false;
    }
    /**
     * Programmatically perform a search if `interactive-icon` is set
     */
    search() {
        if (this.innerSearchButton) {
            this.innerSearchButton.click();
        }
    }
    /**
     * @private
     */
    [(_HznSearchInput_emit = new WeakMap(), _HznSearchInput_instances = new WeakSet(), _HznSearchInput_handleSearchButtonClick = function _HznSearchInput_handleSearchButtonClick(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        if (this.form) {
            submit(this.form);
        }
        else {
            __classPrivateFieldGet(this, _HznSearchInput_emit, "f").call(this, { type: 'search' });
        }
    }, hasNoSlottedIcon)]() {
        return true;
    }
    /**
     * @private
     */
    [renderIconSlot]() {
        if (this.interactiveIcon && (!this.disabled && !this.readonly)) {
            return html `<span class="search-button">
        <button @click=${__classPrivateFieldGet(this, _HznSearchInput_instances, "m", _HznSearchInput_handleSearchButtonClick)}>
          <span class="visually-hidden">Click to search</span>
          <hzn-icon-search></hzn-icon-search>
        </button>
    </span>`;
        }
        return html `<span class="trailing-icon" role="presentation">
      <hzn-icon-search></hzn-icon-search>
    </span>`;
    }
    willUpdate() {
        // hardcoded overrides of hzn-input options
        // these will always be set right before any update
        this.type = 'text';
        this.sensitive = false;
    }
}
__decorate([
    query('.search-button button')
], HznSearchInput.prototype, "innerSearchButton", void 0);
__decorate([
    property({ type: Boolean, attribute: 'interactive-icon' })
], HznSearchInput.prototype, "interactiveIcon", void 0);
//# sourceMappingURL=search-input.js.map